// Tira o nome do presente do url do vídeo antigo, que é o que vai no Firestore.
//
//   /assets/gift_anel_de_campeao-ChF9v2lk.webm      (build: com o hash do Vite)
//   /src/assets/presentes/leves/gift_apito.webm      (desenvolvimento)
//        → "anel_de_campeao" / "apito"
//
// Só reconhece VÍDEOS de presente (gift_*.webm|mp4|mov). A imagem de um lucky
// ("lucky_anel_de_campeao.webp") ou a miniatura ("gift_apito.webp") dão null.
// Os nomes dos presentes só usam letras, números e "_"; o "-" é o do hash.
export function nomeDoPresente(url) {
  const m = /(?:^|\/)gift_([a-z0-9_]+)(?:-[A-Za-z0-9_-]+)?\.(?:webm|mp4|mov)(?:[?#]|$)/i.exec(String(url || ''));
  return m ? m[1].toLowerCase() : null;
}
